import { forwardRef } from 'react'
import { cn } from '../lib/cn.js'
import { Campo } from './Campo.js'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  rotulo: string
  dica?: string | undefined
  erro?: string | undefined
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { rotulo, dica, erro, className, required, maxLength, value, ...resto },
  ref,
) {
  const usados = typeof value === 'string' ? value.length : 0
  return (
    <Campo rotulo={rotulo} dica={dica} erro={erro} obrigatorio={required}>
      {({ id, descritoPor, invalido }) => (
        <span className={cn('du-entrada du-entrada--area', className)}>
          <textarea
            ref={ref}
            id={id}
            rows={resto.rows ?? 3}
            maxLength={maxLength}
            value={value}
            aria-describedby={descritoPor}
            aria-invalid={invalido || undefined}
            required={required}
            {...resto}
          />
          {maxLength ? (
            <span className="du-entrada__contador" aria-hidden>
              {usados}/{maxLength}
            </span>
          ) : null}
        </span>
      )}
    </Campo>
  )
})
